import React from "react";
import axios from "axios";
import url from "../helpers/url";
import { UserContext } from "./user";
import { eachOrder } from "../helpers/helpers";

export const CartServerSide = React.createContext();

const CartServerSideProvider = (props) => {
  const { user } = React.useContext(UserContext);

  React.useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    let response = await axios
      .get(`${url}/users/me`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      })
      .catch(() => {
        console.clear();
      });
    if (response) {
      setUserInfo(response.data);
      setCart(response.data.cart);
      setOrders(eachOrder(response.data.orders));
    } else {
      console.clear();
    }
  };

  const [cart, setCart] = React.useState([]);
  const [orders, setOrders] = React.useState([]);
  const [userInfo, setUserInfo] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const [forceRerender, setForceRerender] = React.useState(false);

  React.useEffect(() => {
    fetchUserData();
  }, [user, forceRerender]);

  React.useEffect(() => {
    let newTotal = cart.reduce((total, cartItems) => {
      if (cartItems.get_size === "small") {
        return cartItems.get_crust === "Thick crust"
          ? (total += cartItems.amount * cartItems.price_small + 1.15)
          : (total += cartItems.amount * cartItems.price_small);
      }

      if (cartItems.get_size === "medium") {
        return cartItems.get_crust === "Thick crust"
          ? (total += cartItems.amount * cartItems.price_medium + 1.25)
          : (total += cartItems.amount * cartItems.price_medium);
      }

      if (cartItems.get_size === "large") {
        return cartItems.get_crust === "Thick crust"
          ? (total += cartItems.amount * cartItems.price_large + 1.25)
          : (total += cartItems.amount * cartItems.price_large);
      } else {
        return (total += cartItems.amount * cartItems.price_small);
      }
    }, 0);
    newTotal = parseFloat(newTotal).toFixed(2);
    setTotal(newTotal);
  }, [cart]);

  return (
    <CartServerSide.Provider
      value={{ cart, setCart, total, userInfo, setForceRerender, orders }}
    >
      {props.children}
    </CartServerSide.Provider>
  );
};

export { CartServerSideProvider as default };
